/* eslint-disable no-console */
import React, { useState, useEffect } from 'react'

import { useInView } from 'react-cool-inview'

import axios from 'axios'

import DesignerInfo from 'Pods/Shared/PrintModels/components/DesignerInfo'
import DesignerModel from 'Pods/Shared/PrintModels/components/DesignerModel'
import getLocaleParam from 'Pods/Shared/Utils/getLocaleParam'

function DesignerSection() {
  const [userInfo, setUserInfo] = useState(null)
  const [wasViewed, setWasViewed] = useState(false)

  const { observe } = useInView({
    threshold: 0.5,
    onEnter: ({ unobserve }) => {
      if (!wasViewed) {
        setWasViewed(true)
      }
      unobserve() // unobserve to avoid multiple impressions on same item.
    },
  })

  const fetchDesigners = () => {
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
    const locale = getLocaleParam()
    const config = locale ? { params: { locale } } : {}

    axios.get('/api/internal/featured_designers', config)
      .then(onFetchSuccess)
      .catch((error) => { console.log('error fetching ', error) })
  }

  const reportImpression = (id) => {
    if (id) {
      axios.post(`/api/internal/featured_designers/${id}/track`)
        .then(() => { })
        .catch(() => { console.log('error') })
    }
  }

  const onFetchSuccess = (response) => {
    const { data } = response
    setUserInfo(data)
  }

  useEffect(() => {
    const hasUserInfo = userInfo !== null

    if (!hasUserInfo) {
      fetchDesigners()
    }

    if (wasViewed && hasUserInfo) {
      reportImpression(userInfo.id)
    }
  }, [wasViewed, userInfo])

  if (userInfo && userInfo.id) {
    return (
      <div
        id="featured-designer-section"
        className="info-section featured-designer-section-container"
        data-user-id={userInfo.user.id}
        ref={observe}
      >
        <div className="container-fixed">
          <h2 className="cgt-legacy-heading-h3 cgt-mb-20">Featured Designer</h2>

          <div className="row">
            <div className="col-12 designer-promotions-row">
              <div className="designer-promotions-row__container">
                <div className="designer-promotions-row__list">
                  <div className="designer-promotions-row__item">
                    <DesignerInfo user={userInfo.user} keywords={userInfo.keywords} />
                  </div>
                  {userInfo.products.slice(0, 3).map((product, index) => (
                    <div className="designer-promotions-row__item" key={index}>
                      <DesignerModel {...product} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return null
}

export default DesignerSection
